import { produce } from 'immer'

// Action Types
export const SET_LOADING = 'messages/setLoading'
export const SET_MESSAGE_THREAD = 'messages/setMessageThread'

// Action Creators
export const setLoading = (payload) => ({ type: SET_LOADING, payload })
export const setMessageThread = (payload) => ({ type: SET_MESSAGE_THREAD, payload })

// State
export const initialState = {
  loading: {
    messageThread: false,
  },
  messageThread: [],
}

// Reducer
export default function messagesReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload } = action

    switch (action.type) {
      case SET_LOADING:
        newState.loading = { ...state.loading, ...payload }
        break
      case SET_MESSAGE_THREAD:
        newState.messageThread = payload
        break
      default:
        break
    }
  })
}
